import React from 'react';
import './TradeTable.css';

function TradeTable({ trades, showGuru = false, showProduct = false }) {
  const formatCurrency = (value) => {
    if (value === null || value === undefined) return '-';
    return `$${parseFloat(value).toFixed(2)}`;
  };

  const formatPercent = (value) => {
    if (value === null || value === undefined) return '-';
    const num = parseFloat(value);
    return `${num.toFixed(2)}%`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString();
  };

  const getReturnClass = (percent) => {
    if (!percent) return '';
    return parseFloat(percent) > 0 ? 'positive' : 'negative';
  };

  const getStatusClass = (trade) => {
    const status = trade.status?.toLowerCase() || '';
    // If closed with a loss (negative P/L), show as loss
    if (status === 'closed' && trade.option_profit_loss && parseFloat(trade.option_profit_loss) < 0) {
      return `${status} loss`;
    }
    return status;
  };

  return (
    <div className="trade-table-container">
      <table className="trade-table">
        <thead>
          <tr>
            {showGuru && <th>Guru</th>}
            {showProduct && <th>Product</th>}
            <th>Trade #</th>
            <th>Symbol</th>
            <th>Type</th>
            <th>Option Details</th>
            <th>Entry Date</th>
            <th>Exit Date</th>
            <th>Days Held</th>
            <th>Option Entry</th>
            <th>Option Exit</th>
            <th>Option P/L</th>
            <th>% Return</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {trades && trades.length > 0 ? (
            trades.map((trade) => (
              <tr key={trade.id}>
                {showGuru && (
                  <td className="guru-cell">{trade.guru_name}</td>
                )}
                {showProduct && (
                  <td className="product-cell">{trade.product_name || '-'}</td>
                )}
                <td>{trade.trade_number || '-'}</td>
                <td className="symbol-cell">{trade.symbol}</td>
                <td>
                  {trade.option_type ? (
                    <span className={`option-type-badge ${trade.option_type.toLowerCase()}`}>
                      {trade.option_type}
                    </span>
                  ) : '-'}
                </td>
                <td className="option-data-cell">
                  {trade.option_data ? (
                    <span className="option-details-text">
                      {trade.option_data}
                    </span>
                  ) : '-'}
                </td>
                <td>{formatDate(trade.entry_date)}</td>
                <td>{formatDate(trade.exit_date)}</td>
                <td>{trade.days_held || '-'}</td>
                <td>{formatCurrency(trade.option_entry_price)}</td>
                <td>{formatCurrency(trade.option_exit_price)}</td>
                <td className={getReturnClass(trade.option_profit_loss)}>
                  {formatCurrency(trade.option_profit_loss)}
                </td>
                <td className={getReturnClass(trade.option_percent_return)}>
                  {formatPercent(trade.option_percent_return)}
                </td>
                <td>
                  <span className={`status-badge ${getStatusClass(trade)}`}>
                    {trade.status}
                  </span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={showGuru ? "16" : "15"} className="no-data">
                No trades found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default TradeTable;
